<div class="main">
  <div class="section">

    <div class="top_header">
      <div class="item">
        <div class="label">
          {{'ENROUTE.enRouteVehicles'| translate}}
        </div>

      </div>
      <div class="item all_unit_sec">
        <div>
          <mat-slide-toggle (change)="allUnitData()">
          </mat-slide-toggle>
          <span class="toggle">{{'INPLANT.allUnit'| translate}}</span>
        </div>
        <div class="download_sec" (click)="download();">
          <div> <img src="assets/download-icon-new.svg" alt=""> </div>
        </div>
        <!-- <div class="refresh_btn">
          <mat-icon class="" style="cursor: pointer;" (click)="refresh()">refresh</mat-icon>
        </div> -->
      </div>
    </div>


    <div class="filters">
      <!-- <div class="search_sec">
        <div class="input-container">
          <input class="inputSelect" (keyup)="applyFilter($event.target.value,'vehicleno')" [(ngModel)]="vehicle_number"
            name="filter" placeholder="Vehicle No." type="text">
          <span class="close_img" *ngIf="vehicle_number" (click)="clearVehicleNumber()"><i class="material-icons"
              id="material-icons-close">
              clear
            </i></span>
        </div>
      </div> -->

      <div class="filters_sec">
        <div class="filter">
          <div class="input">
            <input class="inputSelect" (keyup)="applyFilter($event.target.value,'vehicleno')"
              [(ngModel)]="vehicle_number" name="filter" placeholder="Vehicle No." type="text">
            <span class="close_img" *ngIf="vehicle_number" (click)="clearVehicleNumber()"><i class="material-icons"
                id="material-icons-close">
                clear
              </i></span>
          </div>
        </div>
        <div class="filter">
          <div class="input">
            <input type="text" class="inputField" placeholder="From" [(ngModel)]="fromDate"
              (click)="fromDateInput3.open()" [matDatepicker]="fromDateInput3" />
            <mat-datepicker #fromDateInput3 (closed)="getEnRouteVehicles()">
            </mat-datepicker>
            <span class="material-icons dateIcon"> <img src="assets/calender-icon.svg" alt=""> </span>
          </div>
        </div>
        <div class="filter">
          <div class="input">
            <input type="text" class="inputField" placeholder="To" [(ngModel)]="toDate" (click)="toDateInput3.open()"
              [matDatepicker]="toDateInput3" />
            <mat-datepicker #toDateInput3 (closed)="getEnRouteVehicles()">
            </mat-datepicker>
            <span class="material-icons dateIcon"> <img src="assets/calender-icon.svg" alt=""> </span>
          </div>
        </div>
        <div style="cursor: pointer;margin-top: 8px;" (click)="getEnRouteVehicles()">
          <img src="assets/refresh-icon.svg" alt="">
        </div>
      </div>
    </div>
    <div class="body">
      <div class="table">
        <table mat-table [dataSource]="enRouteVehicles">

          <ng-container matColumnDef="sno">
            <th mat-header-cell *matHeaderCellDef> {{'ENROUTE.sno'| translate}} </th>
            <td mat-cell *matCellDef="let element; let i = index"> {{i+1}} </td>
          </ng-container>

          <ng-container matColumnDef="vehicleDetails">
            <th mat-header-cell *matHeaderCellDef> {{'ENROUTE.vehicleDetails'| translate}} </th>
            <td mat-cell *matCellDef="let element">
              <!-- {{element.vehicle}} -->
              <div *ngIf="element.tracker" (click)="$event.stopPropagation();">
                <a href="{{ element.tracker }}" target="_blank">
                  <span>
                    {{element.vehicle}}
                  </span>
                </a>
              </div>
              <div *ngIf="!element.tracker">
                {{element.vehicle}}
              </div>
            </td>

          </ng-container>


          <ng-container matColumnDef="address">
            <th mat-header-cell *matHeaderCellDef> {{'ENROUTE.address'| translate}} </th>
            <td mat-cell *matCellDef="let element">{{element.currlocation}} <br /> {{element.currlocationTime}}</td>
          </ng-container>

          <ng-container matColumnDef="driverDetails">
            <th mat-header-cell *matHeaderCellDef> {{'ENROUTE.driverDetails'| translate}} </th>
            <td mat-cell *matCellDef="let element">{{element.name}}<br />{{element.mobile}} </td>
          </ng-container>


         <ng-container matColumnDef="carrierDetails">
              <th mat-header-cell *matHeaderCellDef> {{'ENROUTE.shipperDetails'| translate}} </th>
              <td mat-cell *matCellDef="let element" matTooltip={{element.supportnumber}}> {{element.shipper.parent_name || 'N/A'}}</td>
            </ng-container>
          <ng-container matColumnDef="customerDetails">
            <th mat-header-cell *matHeaderCellDef> {{'ENROUTE.customerDetails'| translate}} </th>
            <td mat-cell *matCellDef="let element">{{element.cust_name}} <br />
              {{element.destination}}</td>
          </ng-container>

          <ng-container matColumnDef="estimatedDeliveryDate">
            <th mat-header-cell *matHeaderCellDef> {{'ENROUTE.estimatedDeliveryDate'| translate}} </th>
            <td mat-cell *matCellDef="let element"> {{(element.updateETA !='N/A' && element.updateETA) ?
              element.updateETA : element.initialETA }}</td>
          </ng-container>

          <ng-container matColumnDef="gateEntry">
            <th mat-header-cell *matHeaderCellDef> {{'ENROUTE.gateEntry'| translate}} </th>
            <td mat-cell *matCellDef="let element"> {{element.entry_no}} </td>
          </ng-container>

          <ng-container matColumnDef="material">
            <th mat-header-cell *matHeaderCellDef> {{'ENROUTE.material'| translate}} </th>
            <td mat-cell *matCellDef="let element"> {{element.material}} </td>
          </ng-container>

          <ng-container matColumnDef="etaSlab">
            <th mat-header-cell *matHeaderCellDef> {{'ENROUTE.etaSlab'| translate}} </th>
            <td mat-cell *matCellDef="let element"> {{element.slabETA}} </td>
          </ng-container>

          <ng-container matColumnDef="gateout">
            <th mat-header-cell *matHeaderCellDef> {{'ENROUTE.gateouttime'| translate}} </th>
            <td mat-cell *matCellDef="let element"> {{element.gateouttime}} </td>
          </ng-container>

          <ng-container matColumnDef="idleSince">
            <th mat-header-cell *matHeaderCellDef> {{'ENROUTE.idleSince'| translate}} </th>
            <td mat-cell *matCellDef="let element"> {{element.idleSince}} </td>
          </ng-container>

          <ng-container matColumnDef="remarks">
            <th mat-header-cell *matHeaderCellDef> {{'ENROUTE.delayReason'| translate}} </th>
            <td mat-cell *matCellDef="let element" matTooltip={{element.delayReason}}> {{element.delayReason[0]}} </td>
          </ng-container>

          <ng-container matColumnDef="customerLocationEntry">
            <th mat-header-cell *matHeaderCellDef> {{'ENROUTE.customerLocationEntry'| translate}} </th>
            <td mat-cell *matCellDef="let element"> {{element.custEntTime}} </td>
          </ng-container>

          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef> {{'ENROUTE.action'| translate}} </th>
            <td mat-cell *matCellDef="let element" style="width: 60px;">
              <div class="action_item">
                <mat-icon class="more-icon" style="cursor: pointer;transform: rotate(90deg)"
                  [matMenuTriggerFor]="actions" (click)="$event.stopPropagation()">
                  more_vert</mat-icon>
              </div>
              <!-- <mat-icon class="more-icon" style="cursor: pointer" [matMenuTriggerFor]="actions"
                (click)="$event.stopPropagation()">
                more_vert</mat-icon> -->
              <mat-menu #actions="matMenu">
                <button mat-menu-item (click)="$event.stopPropagation();openUpdateRemarks(element)">{{'ENROUTE.edit' |
                  translate}}</button>
              </mat-menu>

            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
          <tr mat-row *matRowDef="let row;let i=index; columns: displayedColumns;"
            [ngClass]="{'highlightTableColor': selectedRowIndex == i}" (click)="getOrderStatus(row,i);"></tr>
        </table>

      </div>
      <mat-paginator fixed [length]="enRouteVehicles ? totalvehicles : 0" [pageSize]="200"
        [pageSizeOptions]="[200, 400, 500]" showFirstLastButtons (page)="pageNavigate($event)"></mat-paginator>
    </div>
  </div>
</div>

<ng-template #addRemarkDialog>
  <div class="dialog">
    <div class="dialog_header">
      <div class="dialog_title">{{'ENROUTE.delay_reason'| translate}}</div>
      <div class="dialog_close" (click)="dialogRef.close()">
        <i class="material-icons">close</i>
      </div>
    </div>
    <div class="dialog_body">
      <div class="input-container editInput">
        <input type="text" class="formField" required="required" [(ngModel)]="delay_reason"
          placeholder="Delay Reason" />
        <!-- <mat-autocomplete #remarks="matAutocomplete">
          [matAutocomplete]="remarks"
          <mat-option *ngFor="let reason of reasons | filter: delay_reason" [value]="reason">
            <span>{{ reason }}</span>
          </mat-option>
        </mat-autocomplete> -->
      </div>
    </div>
    <div class="dialog_footer">
      <div class="dialog_footer_btn" (click)="updateRemarks()">{{'DEDICATED.submit'| translate}}</div>
    </div>
  </div>
</ng-template>